<template>
  <button
    class="acButton"
    :class="[
      variant ? `-${variant}` : '',
      icon ? `-icon` : '',
      block ? `-block` : '',
      disabled ? `-disabled` : ''
    ]"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

defineProps({
  block: {
    type: Boolean,
    default: false
  },
  icon: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String as PropType<'tonal' | 'outlined' | 'text'>,
    default: null
  }
})
</script>

<style lang="scss">
  .acButton {
    cursor: pointer;
    border-radius: 4px;
    padding: 16px;

    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    color: var(--ac-color-white);
    background-color: var(--ac-color-blue);
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;

    &.-block {
      width: 100%;
    }

    &.-icon {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    }

    &.-disabled,
    &[disabled] {
      opacity: 0.3;
      cursor: default;
    }

    &.-text {
      background: transparent;
      border: none;
    }

    &.-outlined {
      color: var(--ac-color-blue);
      background-color: transparent;
      border: 1px solid var(--ac-color-blue);
    }
  }
</style>
